export enum FeatureId {
  map = 'map',
  photo = 'photo',
  feedbacks = 'feedbacks',
}
